import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login';
import Home from '../components/Home';
import Pos from "../components/Pos";
import Setting from "../components/Setting";
import Report from "../components/Report";
import Products from "../components/Products";
import Purchase from "../components/Purchase";
import Customers from "../components/Customers";
import Orders from "../components/Orders";
import MoveJobs from "../components/MoveJobs";
import Express from "../components/Express";
import VModal from 'vue-js-modal'
import InputTag from 'vue-input-tag';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueXlsx from 'vue-js-xlsx'
import CalendarView from "../components/CalendarView";
import Manifests from "../components/Manifests";
import CompanySetting from "../components/CompanySetting";
import Sales from "../components/Sales";
import Airlines from "../components/Airlines.vue";

Vue.use(VueXlsx)
Vue.use(VModal, { dialog: true, width:'90%' })

Vue.use(Router)
Vue.component('input-tag', InputTag)
//Vue.component('multiselect', Multiselect)
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/static/css/print.css'
  ]
}

// import * as firebase from "firebase/app";
//
// // Add the Firebase services that you want to use
// import "firebase/auth";
// import "firebase/storage";
//
// var firebaseConfig = {
//   apiKey: "AIzaSyC31PWyIQctMUltFiUEk3tHYnKvtO4JteY",
//   authDomain: "uko-projects.firebaseapp.com",
//   databaseURL: "https://uko-projects.firebaseio.com",
//   projectId: "uko-projects",
//   storageBucket: "uko-projects.appspot.com",
//   messagingSenderId: "81206162832",
//   appId: "1:81206162832:web:926b9745a50d1466f86f15",
//   measurementId: "G-XK8VTY9ZQE"
// };
// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);

Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet

Vue.use(VueHtmlToPaper);
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/pos',
      name: 'Pos',
      component: Pos
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/report',
      name: 'Report',
      component: Report
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders
    },
    {
      path: '/products',
      name: 'Products',
      component: Products
    },
    {
      path: '/purchase',
      name: 'Purchase',
      component: Purchase
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/customers',
      name: 'Customers',
      component: Customers
    },
    {
      path:'/moveJobs',
      name: 'MoveJobs',
      component: MoveJobs
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: CalendarView
    },
    {
      path: '/manifests',
      name: 'Manifests',
      component: Manifests
    },
    {
      path: '/airlines',
      name: 'Airlines',
      component: Airlines
    },
    {
      path: '/sales',
      name: 'Sales',
      component: Sales
    },
    {
      path:'/express',
      name: 'Express',
      component: Express
    },
    {
      path:'/company',
      name: 'Company',
      component: CompanySetting
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js